import type { FunctionComponent } from 'react';
import { paletteHelper, Text, typographyHelper } from '@property.com.au/ui-kit';
import styled from 'styled-components';
import { DialogModal } from '../../../../../app-kit/components/DialogModal/DialogModal';

interface SupplyDemandPerformanceDisclaimer {
  opened: boolean;
  onClose: () => void;
}

const BodyText = styled(Text)`
  ${typographyHelper('body01')};
  color: ${paletteHelper('textSecondary')};
`;

export const SupplyDemandPerformanceDisclaimerContent: FunctionComponent = () => (
  <>
    <BodyText>
      Potential buyers shows the number of people who are seriously interested in buy listings with
      the same number of bedrooms, property type and suburb as this property on realestate.com.au.
    </BodyText>
    <BodyText>
      The number of potential buyers is determined by aggregating both MyREA members and anonymous
      users, and takes into account usage of multiple devices by the same user.
    </BodyText>
    <BodyText>
      &quot;Similar for sale&quot; shows the number of buy listings with the same number of
      bedrooms, property type and suburb as this property on realestate.com.au.
    </BodyText>
    <BodyText>
      Legal information about potential buyers. The potential buyers information is calculated using
      a data science model and is not specific to this property. The potential buyers information
      should not be relied upon as an accurate representation of the potential buyers for this
      property. The potential buyers information we present should not be relied upon as a
      prediction or indication of the intent of realestate.com.au or property.com.au users,
      including whether or how likely such users may be to bid on or make an offer on any particular
      property. realestate.com.au Pty Ltd makes no warranty as to the accuracy or reliability of the
      information contained in the potential buyers data and realestate.com.au Pty Ltd and its
      related entities, directors, officers and agents disclaim all liability and responsibility for
      any direct or indirect loss or damage which may be suffered by any person relying on any
      information contained in or omitted from our potential buyers data.
    </BodyText>
  </>
);

export const SupplyDemandPerformanceDisclaimer: FunctionComponent<
  SupplyDemandPerformanceDisclaimer
> = ({ opened, onClose }) => {
  return (
    <DialogModal
      opened={opened}
      onClose={onClose}
      title="How we calculate this information"
      primaryButtonText="Got it"
      primaryButtonOnClick={onClose}
    >
      <SupplyDemandPerformanceDisclaimerContent />
    </DialogModal>
  );
};
